import { BrandId } from '@hyphengroup/cms-components/utils/override';
import { LoanSearchParams } from '@hyphengroup/cms-components/utils/searchParams/loanSearchParams';
export { type LoanSearchParams } from '@hyphengroup/cms-components/utils/searchParams/loanSearchParams';

export const getLoanSearchParamsWithDefaultComponentParam = (
  brand: BrandId,
  urlParams?: Partial<LoanSearchParams>,
  componentDefault?: Partial<LoanSearchParams>,
): LoanSearchParams => {
  const queryAmount = urlParams?.amount ?? urlParams?.cms_amount;
  const queryTenure = urlParams?.tenure ?? urlParams?.cms_tenure;

  const defaultAmount = (() => {
    switch (true) {
      case !!queryAmount:
        return queryAmount;
      case !!componentDefault?.amount:
        return componentDefault.amount;
      case brand === 'singsaver':
        return '15000';
      case brand === 'moneyhero':
        return '300000';
      default:
        return '30000';
    }
  })();

  const defaultTenure = (() => {
    switch (true) {
      case !!queryTenure:
        return queryTenure;
      case !!componentDefault?.tenure:
        return componentDefault.tenure;
      case brand === 'singsaver':
        return '36';
      case brand === 'moneyhero':
        return '24';
      default:
        return '12';
    }
  })();

  const params: LoanSearchParams = {
    amount: defaultAmount,
    tenure: defaultTenure,
  };

  return params;
};
